import { Component } from "@angular/core";
import { ActivityService } from "../../services/activity.service";
import { AuthenticationService } from "../../../core/core";
import { ActivityTypeBaseComponent } from "../activity-type-base/activity-type-base.component";
import { ToastrService } from "ngx-toastr";
@Component({
  selector: "common-activity-data-entry",
  templateUrl: "./activity-data-entry.component.html",
  styleUrls: ["./activity-data-entry.component.scss"],
})
export class ActivityDataEntryComponent extends ActivityTypeBaseComponent {
  constructor(activityService: ActivityService, authService: AuthenticationService, toastr: ToastrService) {
    super(activityService, authService, toastr);
  }
}
